/**
 * Lädt das Google Tag Manager Script dynamisch.
 * Wird ausschließlich nach Cookie-Consent aufgerufen.
 */

const GTM_ID = 'GTM-T8C339SZ';
let gtmLoaded = false;

export function loadGTM(containerId = GTM_ID) {
  if (gtmLoaded) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // DataLayer initialisieren und Start-Event pushen
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // GTM-Script asynchron einbinden
  const f = document.getElementsByTagName('script')[0];
  const j = document.createElement('script');
  j.async = true;
  j.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  j.setAttribute('data-cookieconsent', 'gtm');
  f.parentNode.insertBefore(j, f);

  // Noscript-Fallback (für Browser, die JS später deaktivieren oder Print)
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  gtmLoaded = true;
}

export const GTM_CONTAINER_ID = GTM_ID;

/**
 * trackEvent — First-Party + GTM Tracking eines anonymen Events.
 * Pusht in den dataLayer (für GTM/GA, falls Consent) und sendet einen
 * anonymen Beacon an das eigene Backend (immer, ohne PII).
 */
export function trackEvent(event, props = {}) {
  try {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...props });
    }
  } catch { /* ignore */ }

  try {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    const url = `${base}/api/analytics/cta`;
    const body = JSON.stringify({ cta: event, plan: props.plan || null, source: props.source || null });
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch { /* ignore */ }
}
